import { accessType } from 'app/constants/tourAccessibilityTypes.constants';
import { twisterType as type } from 'app/constants/twisterType.constants';
import { freePoints, removeIdFromParts, userInfoForTour } from '../extraFuncs';

export const emptyTourModel = (user) => {
  const data = {
    title: 'Tour 1',
    lat: '',
    lng: '',
    owner: user.id,
    user,
    created: 0,
    images: [],
    imgids: '',
    videos: [],
    points: [],
    map_zoom: 0,
    map_type: '',
    link: '',
    shortdescription: '',
    description: '',
    duration: 0,
    distance: 0,
    rating: 0,
    tourType: accessType.DEFAULT_ONLY_FOR_ME_TYPE,
    tourClubId: 0,
    arrow_type: 0,
    url: '',
    s: '',
    private: true,
    share_key: '',
    bookmark: false,
    multiDay: false,
    twister_data: {
      direction: 0,
      is_random: true,
      speed_profile: 0,
      slider: 0,
      twister_type: type.RidePlan,
    },
    parts: [
      {
        title: 'Part 1',
        description: '',
        images: [],
        points: [],
        allTourDays: 0,
        parentId: 0,
        multiDay: false,
        duration: 0,
        distance: 0,
        parent_tour_id: 0,
        part_id: 1,
        twister_data: {
          direction: 0,
          speed_profile: 0,
          is_random: true,
          slider: 0,
          twister_type: type.RidePlan,
        },
      },
    ],
  };
  return data;
};

export const cpTourModel = (resp, user) => {
  const {
    multiDay = false,
    parts,
    pointsData,
    unpaved,
    highway,
    ferry,
    isShapingVisible,
    title,
    points,
    lat,
    lng,
    distance,
    duration,
    map_zoom: mapZoom,
    twister_data,
  } = resp.data.response;
  const data = {
    title: `${title}-COPY`,
    lat,
    lng,
    owner: user.id,
    user,
    created: 0,
    images: [],
    imgids: '',
    videos: [],
    map_zoom: mapZoom,
    map_type: '',
    link: '',
    shortdescription: '',
    description: '',
    duration,
    distance,
    rating: 0,
    tourType: accessType.DEFAULT_ONLY_FOR_ME_TYPE,
    tourClubId: 0,
    arrow_type: 0,
    url: '',
    s: '',
    private: true,
    share_key: '',
    bookmark: false,
    multiDay,
    twister_data: twister_data || {
      direction: 0,
      speed_profile: 0,
      is_random: true,
      slider: 0,
      twister_type: type.RidePlan,
    },
    parts:
      multiDay === true && parts && parts.length > 0
        ? removeIdFromParts(parts, userInfoForTour(user))
        : [
            {
              title: 'Part 1',
              description: '',
              images: [],
              points: freePoints(points),
              allTourDays: 0,
              parentId: 0,
              multiDay: false,
              duration: 0,
              distance: 0,
              parent_tour_id: 0,
              part_id: 1,
              twister_data: {
                direction: 0,
                speed_profile: 0,
                is_random: true,
                slider: 0,
                twister_type: type.RidePlan,
              },
            },
          ],
    points: freePoints(points),
    pointsData,
    unpaved,
    highway,
    ferry,
    isShapingVisible,
  };
  return data;
};

export const cpTourPartModel = (resp, user) => {
  const {
    multiDay = false,
    parts,
    pointsData,
    unpaved,
    highway,
    ferry,
    isShapingVisible,
    title,
    points,
    lat,
    lng,
    distance,
    duration,
    map_zoom: mapZoom,
    twister_data,
  } = resp;
  const data = {
    title: `${title}-COPY`,
    lat,
    lng,
    owner: user.id,
    user,
    created: 0,
    images: [],
    imgids: '',
    videos: [],
    map_zoom: mapZoom,
    map_type: '',
    link: '',
    shortdescription: '',
    description: '',
    duration,
    distance,
    rating: 0,
    tourType: accessType.DEFAULT_ONLY_FOR_ME_TYPE,
    tourClubId: 0,
    arrow_type: 0,
    url: '',
    s: '',
    private: true,
    share_key: '',
    bookmark: false,
    multiDay,
    twister_data: twister_data || {
      direction: 0,
      speed_profile: 0,
      is_random: true,
      slider: 0,
      twister_type: type.RidePlan,
    },
    parts:
      multiDay === true && parts && parts.length > 0
        ? removeIdFromParts(parts, userInfoForTour(user))
        : [
            {
              title: 'Part 1',
              description: '',
              images: [],
              points: freePoints(points),
              allTourDays: 0,
              parentId: 0,
              multiDay: false,
              duration: 0,
              distance: 0,
              parent_tour_id: 0,
              part_id: 1,
              twister_data: {
                direction: 0,
                speed_profile: 0,
                is_random: true,
                slider: 0,
                twister_type: type.RidePlan,
              },
            },
          ],
    points: freePoints(points),
    pointsData,
    unpaved,
    highway,
    ferry,
    isShapingVisible,
  };
  return data;
};
